import React from 'react';

type PillColor = 'red' | 'yellow' | 'blue' | 'gray' | 'purple' | 'green';

interface FilterPillProps {
  label: string;
  active: boolean;
  onClick: () => void;
  color?: PillColor;
  count?: number;
  icon?: string;
  className?: string;
}

const colorClasses: Record<PillColor, { base: string; active: string }> = {
  red: {
    base: 'bg-white text-gray-700 border-gray-300 hover:border-red-400',
    active: 'bg-red-100 text-red-800 border-red-300 ring-2 ring-red-500 ring-opacity-50',
  },
  yellow: {
    base: 'bg-white text-gray-700 border-gray-300 hover:border-amber-400',
    active: 'bg-amber-100 text-amber-800 border-amber-300 ring-2 ring-amber-500 ring-opacity-50',
  },
  blue: {
    base: 'bg-white text-gray-700 border-gray-300 hover:border-blue-400',
    active: 'bg-blue-100 text-blue-800 border-blue-300 ring-2 ring-blue-500 ring-opacity-50',
  },
  gray: {
    base: 'bg-white text-gray-700 border-gray-300 hover:border-gray-400',
    active: 'bg-gray-100 text-gray-800 border-gray-400 ring-2 ring-gray-500 ring-opacity-50',
  },
  purple: {
    base: 'bg-white text-gray-700 border-gray-300 hover:border-purple-400',
    active: 'bg-purple-100 text-purple-800 border-purple-300 ring-2 ring-purple-500 ring-opacity-50',
  },
  green: {
    base: 'bg-white text-gray-700 border-gray-300 hover:border-green-400',
    active: 'bg-green-100 text-green-800 border-green-300 ring-2 ring-green-500 ring-opacity-50',
  },
};

export const FilterPill: React.FC<FilterPillProps> = ({
  label,
  active,
  onClick,
  color = 'gray',
  count,
  icon,
  className = '',
}) => {
  const colors = colorClasses[color];
  const pillClasses = active ? colors.active : colors.base;

  return (
    <button
      onClick={onClick}
      className={`
        inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium
        border transition-all duration-150
        ${pillClasses}
        ${className}
      `}
    >
      {icon && <span className="text-base leading-none">{icon}</span>}
      <span>{label}</span>
      {count !== undefined && (
        <span className="ml-0.5 text-xs font-semibold opacity-75">({count})</span>
      )}
    </button>
  );
};
